{
  "imprint-page": {
    "meta": {
      "title": "Beauty Booking: Imprint",
      "description": "Imprint"
    },
    "text": {
      "title": "Imprint",
      "address-and-contact-data": "ADDRESS AND CONTACT DATA ACCORDING TO § 5 TMG",
      "address": "Address",
      "commercial-register": "Commercial Register",
      "contact": "Contact",
      "email": "Email",
      "legal-representatives": "Legal Representatives",
      "liability": "LIABILITY",
      "liability-text-1": "We are responsible for the content of our websites in accordance with the provisions of general law, in particular in accordance with § 7 (1) of the German Telemedia Act (TMG). All contents are created with due care and to the best of our knowledge. Insofar as we refer to the Websites of third parties by means of hyperlinks on our websites, we cannot assume any guarantee for the continuous topicality, correctness and completeness of the linked contents, because these contents lie outside our area of responsibility, and we have no influence on the future design. If, in your opinion, any content violates applicable law or is inappropriate, please let us know.",
      "liability-text-2": "The legal information on this page as well as all questions and disputes in connection with the design of this website are subject to the laws of the Federal Republic of Germany.",
      "telephone": "Telephone",
      "vat-id": "VAT ID (Ust-ID)"
    }
  }
}
